import { getErrorMessage } from '../useLayer7Notify';

// Fake id used because we can only access the current user context
export const CurrentUserId = 'layer7@currentUser';

class UserContextsValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = 'UserContextsValidationError';
        this.status = 400;
    }
}

export const userContextsDataProvider = context => {
    const basePath = `${context.apiUrl}/userContexts`;
    const newPath = `${context.apiUrl}/userProfile`;

    return {
        getOne: async () => {
            const { json: data } = await context.fetchJson(basePath, {
                credentials: 'include',
            });

            if (!data || !data.userContexts || !data.userContexts.length > 0) {
                const customError = {
                    status: 404,
                    message:
                        'resources.userContexts.notifications.profile_not_exist_error',
                };
                throw customError;
            }

            const response = await context.fetchJson(newPath, {
                credentials: 'include',
            });

            const userContext = data.userContexts[0];
            userContext.userDetails.firstName = response?.json?.firstName;
            userContext.userDetails.lastName = response?.json?.lastName;
            userContext.userDetails.email = response?.json?.email;

            return {
                data: { ...userContext, id: CurrentUserId },
            };
        },
        update: async ({ id, data }) => {
            // The update method should only be used to update the user details

            const {
                userDetails: { firstName, lastName, email },
            } = data;

            try {
                await context.fetchJson(newPath, {
                    credentials: 'include',
                    method: 'PUT',
                    body: JSON.stringify({
                        firstName,
                        lastName,
                        email,
                    }),
                });
            } catch (error) {
                const message = getErrorMessage(error);
                throw new UserContextsValidationError(message);
            }

            return {
                data: {
                    id,
                    ...data,
                },
            };
        },
        updateActiveOrganization: async ({ id, data }) => {
            // The updateActiveOrganization method should only be used to update the user active organization

            try {
                await context.fetchJson(basePath, {
                    credentials: 'include',
                    method: 'PUT',
                    body: JSON.stringify({
                        orgUuid: data.activeOrgUuid,
                    }),
                });
            } catch (error) {
                const message = getErrorMessage(error);
                throw new UserContextsValidationError(message);
            }

            return {
                data: {
                    id,
                    ...data,
                },
            };
        },
    };
};
